import { Attributes, List, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';
import ContactDetail from '../Contacts/ContactDetail';
import InternalApproverPortalUser from './InternalApproverPortalUser';

export default class InternalApprover extends TemporalEntity {
    static typeName = "InternalApprover";

    constructor() {
        super();
        this.makeObservable();
    }

    public internalApproverId: number = 0;

    public users = new List(InternalApproverPortalUser);

    @Attributes.ChildObject(ContactDetail, true)
    public values: ContactDetail = new ContactDetail();

    // Client only properties / methods

    @Attributes.DisplayMember()
    public get display() {
        return this.values.fullName;
    }

    protected static addBusinessRules(rules: Validation.Rules<InternalApprover>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New internal approver";
        } else {
            return "Internal Approver";
        }
    }
}